import { catchError, map, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { apiUrls } from '../../../../constants/api-urls.constant';
import { BaseOrderResponse } from '../../oms/models/orderModels.model';
import { BaseService, SymbolService } from '../../../../modules/shared/services';
import { AlgoOrder, IAlgoOrderCreateRequest, IAlgoOrderCreateResponse } from '../models/algo-order.model';
import { IAlgoOrderHistoryResponse, IAlgoOrderResponse, IBaseAlgoOrder } from '../models/algo-order.model';

export interface AlgoFilter {
	from: string;
	to: string;
	side: number;
	state: string;
	symbolIsin: string;
	page: number;
	size: number;
	referenceId?: string | number;
}
@Injectable({ providedIn: 'root' })
export class ALgoOrderService extends BaseService {
	symbolService = inject(SymbolService);
	private get algoUrl(): string {
		return this.mtsPath + apiUrls.algo;
	}
	private get algoHistoryUrl(): string {
		return this.mtsPath + apiUrls.algoHistory;
	}
	getHistory(input: Partial<AlgoFilter>) {
		const body = {
			page: input.page + 1,
			size: input.size,
			history: true
		};
		if (input?.from) body['from'] = input.from;
		if (input?.to) body['to'] = input.to;
		if (+input?.side >= 0) body['side'] = input.side;
		if (+input?.state > 0) body['state'] = input.state.toString();
		if (input?.symbolIsin) body['symbolIsin'] = input.symbolIsin;
		if (input?.referenceId) body['referenceId'] = input.referenceId;

		return this.httpService
			.post<IAlgoOrderHistoryResponse>(this.algoHistoryUrl, { body, guestUserRestriction: true })
			.pipe(
				map(res => {
					const orderItemDto = res.orderItemDto.map(this.mapData);
					return { ...res, orderItemDto };
				}),

				catchError(() => {
					return of({ orderItemDto: [], totalCount: 0 } as IAlgoOrderResponse);
				})
			);
	}
	get() {
		return this.httpService
			.post<IAlgoOrderHistoryResponse>(this.algoHistoryUrl, { body: {}, guestUserRestriction: true })
			.pipe(
				map(res => [...res.orderItemDto]),
				map(res => res.map(this.mapData)),

				catchError(() => {
					return of([] as IBaseAlgoOrder[]);
				})
			);
	}
	post(request: IAlgoOrderCreateRequest) {
		return this.httpService
			.post<IAlgoOrderCreateResponse>(this.algoUrl, { body: { request }, guestUserRestriction: true })
			.pipe(
				map(res => ({ ...res, id: res?.id?.toString(), isSuccessful: !!res?.id })),
				catchError(error => {
					return of({
						isSuccessful: false,
						message: error?.error ?? 'خطا در ثبت سفارش'
					} as IAlgoOrderCreateResponse);
				})
			);
	}
	delete(id: string) {
		return this.httpService
			.delete(`${this.algoUrl}`, { body: { request: { ids: [+id] } }, guestUserRestriction: true })
			.pipe(
				map(() => ({ isSuccessful: true }) as BaseOrderResponse),
				catchError(error => {
					return of({
						isSuccessful: false,
						message: error?.error ?? 'خطا در توقف سفارش'
					} as IAlgoOrderCreateResponse);
				})
			);
	}

	mapData = t =>
		new AlgoOrder({
			...t,
			id: t.id?.toString(),
			quantity: t.volume,
			createDateTime: t.submitDateTime,
			executedQuantity: t.volumeDone,
			executingQuantity: t.volumeRemained,
			value: t.volumeDone * t.price,
			averagePrice: t.priceAverage,
			executedValue: t.valueDone,
			executedPercent: Math.round((t.volumeDone / t.volume) * 100),
			executingPercent: Math.round((t.volumeRemained / t?.volume) * 100),
			symbolName: this.symbolService?.symbolByIsin?.[t.symbolIsin]?.symbolName
		});
}
